import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { IMG_URL } from '../../../store/Apis';
import styles from './Profile.module.css';
import dummyImg from '../../../assets/dummy.png';
import moment from 'moment';

const Profile = () => {
    const phoneFormat = (text) => {

        var cleaned = ("" + text).replace(/\D/g, "");
        var match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
    
        if (match) {
            var intlCode = match[1] ? "+1 " : "",
              number = [intlCode, "(", match[2], ") ", match[3], "-", match[4]].join(
                ""
              );
            return number;
          }
          return text;
      }
    const { state } = useLocation();
    const screen = state?.screen == "customerCleaner" ? true : false
    const data = state?.item
    console.log('data', data);

    const { t, i18n } = useTranslation();

    useEffect(() => {
        getLanguage();
    }, [])

    const getLanguage = async () => {
        try {
            const language = localStorage.getItem('@selectedLanguage');
            i18n.changeLanguage(language)
        } catch (e) {
            console.log(e)
        }
    };
    return (
        <div className={styles.mainDiv}>
            {/* <div className={styles.heading}>
            <h1>Customer</h1>
            </div> */}
            <div className={styles.detailDiv}>
                <div className={styles.header}>
                    <div className={styles.headerImg}>
                        {screen ?
                            <img src={data?.cleaner_image ? IMG_URL + data?.cleaner_image : dummyImg} />
                            :
                            <img src={state?.profile_image ? IMG_URL + state?.profile_image : dummyImg} />}

                    </div>
                    <div className={styles.headerContent}>
                        <h1>{screen ? data?.cleaner_name : state?.name}</h1>
                        <p>{screen ? data?.service_type : state?.category_name}</p>
                    </div>
                </div>
                <div className={styles.basicInfoDiv}>
                    <h1>{t("Basic Information")}</h1>
                    <div className={styles.row}>
                        <div className={styles.colLeft}>
                            <span>{t("Email")}</span>
                            <p>{screen ? data?.cleaner_email : state?.email}</p>
                        </div>
                        <div className={styles.colRight}>
                            <span>{t("Address")} 1</span>
                            <p>{screen ? data?.location?.address : state?.address?.[0]?.address}</p>
                        </div>
                    </div>
                    <div className={styles.row}>
                        <div className={styles.colLeft}>
                            <span>{t("Contact Number")}</span>
                            <p>{screen ? phoneFormat(data?.cleaner_contact) : phoneFormat(state?.contact_no)}</p>
                        </div>
                        <div className={styles.colRight}>
                            <span>{t("Work Hours")}</span>
                            <p>{moment(screen ? data?.start_time : state?.working_start_time, 'HHmmss').format('hh:mm A')} to {moment(screen ? data?.end_time : state?.working_end_time, 'HHmmss').format('hh:mm A')}</p>
                        </div>
                    </div>
                    <div className={styles.row}>
                        <div className={styles.colLeft}>
                            <span>{t("Break Hours")}</span>
                            <p>{moment(screen ? data?.break_time_in : state?.break_time_in, 'HHmmss').format('hh:mm A')} to {moment(screen ? data?.break_time_out : state?.break_time_out, 'HHmmss').format('hh:mm A')}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
export default Profile;